import Route from "@ember/routing/route";
import RouterService from "@ember/routing/router-service";
import { service } from "@ember/service";
import SemeiaSessionService from "core/services/session";
import LoginSsoController from "parog-web/controllers/login/sso";

export default class SsoRoute extends Route {
  @service declare session: SemeiaSessionService;
  @service declare router: RouterService;

  queryParams = {
    code: {
      refreshModel: true
    }
  };

  async beforeModel() {
    if (this.session.isAuthenticated) {
      this.router.transitionTo("medics-web.logout");
    }
  }

  resetController(controller: LoginSsoController, isExiting: boolean) {
    if (isExiting) {
      controller.code = undefined;
    }
  }
}
